module.exports = __webpack_public_path__ + "static/codoc2-c487ac8f24806fa4c640c9d26c35845b.gif";